import { createPortal } from "react-dom";

export default function ContextMenuPortal({ children }) {
    return createPortal(children, document.body);
}